export default __webpack_public_path__ + "static/media/guest-ranger-logo.44a486b4.svg";